import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
})
export class DatePickerComponent implements OnInit {
  @Input() time;
  @Output() onDateChanged = new EventEmitter();

  constructor() { }

  ngOnInit() {
    console.log(this.time);
  }

  changeDate(time, name) {
    this.onDateChanged.emit(time);
  }

}
